var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-desktop-2801615") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-830.000000, -435.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(416.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-2",
    transform: "translate(398.153815, 214.233721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-desktop-2801615",
    transform: "translate(16.846185, 16.766279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.404207489,0 C0.179535725,0.0119410302 0.000318869925,0.202049889 0,0.429085523 L0,13.5220664 C0.00140131374,13.7487842 0.182010953,13.9369938 0.406678731,13.9450382 L6.91919836,13.9450382 L6.30122845,16.1749717 L5.19048492,16.1749717 C4.9665904,16.1749717 4.78209227,16.3617815 4.78209227,16.5878881 C4.78209227,16.8138216 4.96690529,17 5.19048492,17 L14.8099934,17 C15.033577,17 15.2191832,16.8141313 15.2191832,16.5878881 C15.2191832,16.3616448 15.0343702,16.1749717 14.8099934,16.1749717 L13.6992499,16.1749717 L13.0815988,13.9450382 L19.5933213,13.9450382 C19.817993,13.9368683 19.9989238,13.748016 20,13.5213021 L20,0.429125745 C19.9996886,0.202094133 19.8203248,0.0121469655 19.5957925,0 L0.407794775,0 L0.404207489,0 Z M0.817104183,0.82518922 L19.1836133,0.82518922 L19.1836133,10.1091713 L0.817104183,10.1097997 L0.817104183,0.82518922 Z M0.817104183,10.9337169 L19.1836133,10.9337169 L19.1836133,13.1199696 L0.817104183,13.1199696 L0.817104183,10.9337169 Z M7.76806996,13.9451588 L12.2322489,13.9451588 L12.8499,16.1743281 L7.15049863,16.1743281 L7.76806996,13.9451588 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.baca3748de5c8754f49e69cc5c03c144.svg";
export { ForwardRef as ReactComponent };